import { placesFwkBootFatalBootAction } from "hybridspace-performance-datapoints";

export function onFatalBootError(): void {
    placesFwkBootFatalBootAction();
}
